import React, { useRef, useEffect, useState } from 'react';
import { getAllThesis } from '../../services/thesisService';
import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';


export const ThesisList=()=> {
    const fileInputRef = useRef(null);
    const [thesis, setThesis] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const fetchThesis = async () => {
        try {
            const data = await getAllThesis();
          //  console.log(data);
            setThesis(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    
    useEffect(() => {
       
        fetchThesis();
    }, []);


    const columns = React.useMemo(
        () => [
            { field: 'thesis_title', headerName: 'Title', width: 170 },
            { field: 'student_name', headerName: 'Student Name', width: 150 },
            { field: 'mentor1_name', headerName: 'Mentor1 Name', width: 150 },
            { field: 'mentor2_name', headerName: 'Mentor2 Name', width: 150 },
            { field: 'thesis_abstract', headerName: 'Abstract', width: 150 },
            { field: 'date_submitted', headerName: 'Recent Submitted Date', width: 150 },
            { field: 'term_type', headerName: 'Term', width: 120 },
            { field: 'report_type', headerName: 'Report Type', width: 120 },
            { field: 'examiner1_feedback', headerName: 'Feedback 1', width: 150 },
            { field: 'examiner2_feedback', headerName: 'Feedback 2', width: 150 }
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/thesis/view-thesis/${id}`}} style={{textDecoration:"none" }}>View</Link></div>
                    <div className="editButton"><Link to={{pathname: `/thesis/edit-thesis/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>

                </div>
            );
        }
    }]

   

    const handleFileChange = (event) => {
        setFile(null);
        const selectedFile = event.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB
        const allowedTypes = [
          //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          //'application/vnd.ms-excel', // .xls
          'text/csv' // .csv
        ];

        if (selectedFile && selectedFile.size > maxFileSize) {
          toast.error('File size exceeds 10 MB limit');
          event.target.value='';
          return;
        }
        else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
          toast.error('Only csv files are allowed');
          event.target.value='';
          return;
        }
        else{
            setFile(selectedFile);
        }
    };

    
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axiosInstance.post('/uploadThesis', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                showToastOnResponse: true
            });

           // console.log(response.data); 
            fetchThesis();// Handle success response
            setFile(null);
            if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.value = '';
              }
        } catch (error) {
            console.error('Error uploading file:', error); // Handle error response
           // console.log(error.response.data) // Handle error response
            setFile(null);
            if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            if(error && (!error.response ||!error.response.data))
            toast.error('Uploaded file changed. Please select file again');
        }
    };
    return (
        <div className="datatable" >
        <div className="datatableTitle">
        <div className="import">
          Import Thesis
         <form onSubmit={handleSubmit}>
            <input type="file" ref={fileInputRef} onChange={handleFileChange} />
            <button type="submit">Upload File</button>
          </form>

         </div>


        </div>
      
      <DataGrid 
      rows={thesis}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

